import { DigitalSignatureRequestStatusInOrder, OriginLoan } from '../@core/constants';
import { InterestFee } from './interest-fee';
import { LoanCondition } from './loan-condition';
import { LoanIntermediary } from './loan-intermediary';
import { LoanReceiptInvoiceDetail } from './loan-receipt-invoice-detail';
import { OrderEntry } from './order-entry';
import { LoanSimulationRequest } from './requests/loan-simulation-request';
import { Voucher } from './voucher';

export class Loan {
  code: string;
  contractNumber: string;
  salesOrg: string;
  status: string;
  productClass: string;
  customerCode: string;
  loanClass: string;
  amount: number;
  currency: string;
  term: string;
  termFormmated: string;
  authorizationDate: string;
  region: string;
  branchCode: string;
  promotion: string;
  invoices: Array<LoanReceiptInvoiceDetail>;
  sellerCode: string;
  sellerName: string;
  totalFinanced: number;
  validDate: string;
  amortizationClass: string;
  periodStartingDate: string;
  periodEndDate: string;
  created: Boolean;
  creationDate: string;
  creationDateFormatted: Date;
  returningDate: string;
  agreementEndDate: string;
  conditions: Array<LoanCondition>;
  intermediaries: Array<LoanIntermediary>;
  isInsured: boolean;
  arrearPercentage: string;
  totalInterests: string;
  signedInCity: string;
  signedInDepartment: string;
  rate: string;
  orderCode: string;
  parameters: LoanSimulationRequest;
  lastPaymentDate: string;
  creditBalance: number;
  contractCanceled: string;
  disputeCase: string;
  interestFee: Array<InterestFee>;
  quotaPaidMT: string;
  originLoan: OriginLoan;
  elapsedDays: number;
  voucher: Voucher;

  //Custom
  delayedAmount: number;

  // for credit logic

  products: Array<OrderEntry> = [];

  cashLoanReasonCode: string;
  cashLoanReasonDescription: string;
  selectedUserBranch: string;
  processingStatusDigitalSignature: DigitalSignatureRequestStatusInOrder;
  canSign: boolean;
  signTimestamp: Date;
  constructor() {
    this.code = '';
    this.contractNumber = '';
    this.salesOrg = '';
    this.status = '';
    this.productClass = '';
    this.customerCode = '';
    this.loanClass = '';
    this.amount = 0.0;
    this.currency = '';
    this.term = '';
    this.termFormmated = '';
    this.authorizationDate = '';
    this.region = '';
    this.branchCode = '';
    this.promotion = '';
    this.invoices = [];
    this.sellerCode = '';
    this.sellerName = '';
    this.totalFinanced = 0.0;
    this.validDate = '';
    this.amortizationClass = '';
    this.periodStartingDate = '';
    this.periodEndDate = '';
    this.created = false;
    this.creationDate = '';
    this.returningDate = '';
    this.agreementEndDate = '';
    this.conditions = [];
    this.intermediaries = [];
    this.isInsured = false;
    this.arrearPercentage = '';
    this.totalInterests = '';
    this.signedInCity = '';
    this.signedInDepartment = '';
    this.rate = '';
    this.orderCode = '';
    this.parameters = new LoanSimulationRequest();
    this.lastPaymentDate = '';
    this.creditBalance = 0.0;
    this.contractCanceled = '';
    this.disputeCase = '';
    this.interestFee = [];
    this.quotaPaidMT = '';
    this.originLoan = OriginLoan.POS;
    this.creationDate = '';
    this.periodStartingDate = '';
    this.delayedAmount = 0;
    this.elapsedDays = 0;
    this.voucher = new Voucher();
    this.creationDateFormatted = new Date();
    this.cashLoanReasonCode = "";
    this.cashLoanReasonDescription = "";
    this.selectedUserBranch = "";
    this.processingStatusDigitalSignature = DigitalSignatureRequestStatusInOrder.UNPROCESSED;
    this.signTimestamp = new Date();
    this.canSign = false;
  }
}
